import { render, staticRenderFns } from "./lrTenantId.vue?vue&type=template&id=515afb02&"
import script from "./lrTenantId.vue?vue&type=script&lang=js&"
export * from "./lrTenantId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports